import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  deleteCartId,
  getCart,
  getOrderHistory,
  increaseDecrease,
} from "../Services/Service";
import UserContext from "../context/UserContext";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";
import { SatelliteIcon } from "evergreen-ui";

const initialValue = {
  discountedTotal: "",
  cartTotal: "",
  totalProducts: "",
  totalQuantity: "",
  userId: "",
  id: "",
};
const initialCart = {
  showCart: "N",
};

const ItemDetails = () => {
  const nav = useNavigate();
  const location = useLocation().state;
  // console.log(location)

  const [cartData, setCartData] = useState([]);
  const [issOpen, setsOpen] = useState();
  const [showCartData, setShowCartData] = useState("Y");
  const [price, setPrice] = useState(initialValue);
  const [time, setTime] = useState(false);
  const { state, update } = useContext(UserContext);

  useEffect(() => {
    if (!location) {
      return nav("/home", { replace: true });
    }
    // let loggedInStatus = localStorage.getItem('auth') ? localStorage.getItem('auth') : 0;
    // if(loggedInStatus===0){
    // //   setsOpen(true);
    //   // return nav('/login',{state:location.pathname})
    // }else{
    // fetchOrderHistoryList();
    // }
  }, []);

  const fetchOrderHistoryList = async () => {
    getOrderHistory()
      .then((res) => {
        if (res.data.status === 1) {
          setShowCartData("Y");
        } else {
          setShowCartData("N");
        }
        return res.data.data;
      })
      .then((res) => {
        const arr = res.map((data) => {
          return { ...data, show: false };
        });
        setCartData(arr);
      });
  };

  const handleClick = (e) => {
    // set
    const arr = cartData;
    arr[e.target.id].show = !arr[e.target.id].show;
    // console.log(arr)
    setCartData([...arr]);
  };
  const [isOpen, setOpen] = useState(false);

  const toggleClass = () => {
    setOpen(!isOpen);
  };

  return (
    <div className="content-apps mt-5">
      <HelmetProvider>
        <Helmet>
          <title>Orders</title>
        </Helmet>
      </HelmetProvider>
      <div className="container">
        <div className="item-details mt-5">
          <div className="row mt-5 ">
            <div className="col-lg-7">
              <div className="card order-list">
                <div className="card-head">
                  <p className="small m-2">
                    Order placed on:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.orderDate}
                    </span>
                  </p>
                  <p className="small m-2">
                    Order ID:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.orderId}
                    </span>
                  </p>
                  <p className="small m-2">
                    Sub Order ID:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.subOrderId}
                    </span>
                  </p>
                </div>
                <div
                  className="card-body ps-0"
                  onClick={() => {
                    return nav(`/productdetails/${location?.productId}`);
                  }}
                >
                  <div className="d-flex mb-2">
                    <img src={location?.productImage[0]} alt="" />
                    <p>
                      {location?.productTitle}
                      <br />
                      <span>₹{location?.finalAmount}</span>
                    </p>
                  </div>
                  <p className="small m-2">
                    Status:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.orderShipped === "Y" ? "Shipped" : "--"}
                    </span>
                  </p>
                  <p className="small m-2">
                    AWN Number:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.awbNumber === "Y" ? location?.awbNumber : "--"}
                    </span>
                  </p>
                  <p className="small m-2">
                    Quantity:{" "}
                    <span className="text-white-50 small">
                      {location?.quantityOrdered}
                    </span>
                  </p>
                  <div className="OrderBy_cancelss d-flex justify-content-between align-items-center">
                    <p className="m-0">
                      {location?.discountAmount} SpiceGold coins have been used
                    </p>
                    <div className="mytooltip position-relative">
                      <i onClick={toggleClass} class="fa fa-info-circle"></i>
                      <span
                        className={`position-absolute ${
                          isOpen ? "d-block" : "d-none"
                        }`}
                      >
                        <p className="m-0">
                          SpiceGold are reversed in case of order cancellations
                          or returns..
                        </p>
                      </span>
                    </div>
                  </div>

                  {location?.digital && (
                    <div className="OrderDetailsHeader__base">
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && (
                        <div className="OrderDetailsHeader__orderPlacedHolder">
                          <div className="OrderDetailsHeader__labelHeader">
                            Activation Code :
                          </div>
                          <div className="OrderDetailsHeader__dataInformationText">
                            {location?.digital["Activation Code"]}
                          </div>
                        </div>
                      )}
                      <div className="OrderDetailsHeader__orderIdHolder OrderDetailsHeader__orderPlacedHolder">
                        <div className="OrderDetailsHeader__labelHeader">
                          Digital Order ID :
                        </div>
                        <div className="OrderDetailsHeader__dataInformationText">
                          {location?.digital["Digital OrderId"]}
                        </div>
                      </div>
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && (
                        <div>
                          <div className="OrderDetailsHeader__labelHeader">
                            Serial No :
                          </div>
                          <div className="OrderDetailsHeader__dataInformationText">
                            {location?.digital["Serial No"]}
                          </div>
                        </div>
                      )}
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && (
                        <div>
                          {
                            <div className="OrderDetailsHeader__labelHeader">
                              Validity :
                            </div>
                          }
                          <div className="OrderDetailsHeader__dataInformationText">
                            {location?.digital["Validity"]}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div
                  className="details-footer"
                  onClick={(e) => {
                    e.stopPropagation();
                    nav("/faq");
                  }}
                >
                  <Link
                    to="/faq"
                    className="d-flex justify-content-between align-items-center text-white small"
                  >
                    <p className="m-0">Help & Support</p>
                    <i class="fa fa-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mb-5 mt-3">
              <div className="card order-list mb-5">
                <div className="card-head border-bottom pb-3">
                  <h4>Payment Details</h4>
                </div>
                <div className="card-body ps-0">
                  <table className="table table-borderless text-white">
                    <tbody>
                      <tr className="small text-white-50">
                        <td>Item Price</td>
                        <td className="text-end">₹ {location?.itemPrice}</td>
                      </tr>
                      <tr className="small text-white-50">
                        <td>Delivery & Shipping Charges</td>
                        <td className="text-end">₹ {0}</td>
                      </tr>
                      <tr className="small text-white-50">
                        <td>Discount</td>
                        <td className="text-end">
                          - {location?.discountAmount}{" "}
                          <img
                            src={"/assets/images/spicegold.png"}
                            alt=""
                            className="mr-0"
                            style={{
                              height: "20px",
                              width: "20px",
                              // marginRight: "1px !important",
                            }}
                          />
                        </td>
                      </tr>
                      <tr className="small text-white-50">
                        <td>Coupon</td>
                        <td className="text-end">-₹ 0</td>
                      </tr>
                      <tr>
                        <td style={{ fontSize: "16px" }}>Total Price</td>
                        <td className="text-end" style={{ fontSize: "16px" }}>
                          {" "}
                          ₹{location?.finalAmount}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="details-footer">
                    <h4 className="fs-6 mb-2">Delivery Address:</h4>
                    <p className="text-white-50 small">
                      <p>
                        {location?.name}, {location?.address}{" "}
                        {location?.landmark} {location?.city}, {location?.state}
                        , {location?.pinCode}
                      </p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 
<div className="OrderByTransaction__base">
<div className="OrderByTransaction__order">
<div className="OrderByTransaction__orderIdHolder">
<div className="OrderDetailsHeader__base">
<div className="OrderDetailsHeader__orderPlacedHolder">
<div className="OrderDetailsHeader__labelHeader">
  Order placed on :
</div>
<div className="OrderDetailsHeader__dataInformationText">
  {location?.orderDate}
</div>
</div>
<div className="OrderDetailsHeader__orderIdHolder OrderDetailsHeader__orderPlacedHolder">
<div className="OrderDetailsHeader__labelHeader">Order ID :</div>
<div className="OrderDetailsHeader__dataInformationText">
  {location?.orderId}
</div>
</div>
<div>
<div className="OrderDetailsHeader__labelHeader">
  Sub Order ID :
</div>
<div className="OrderDetailsHeader__dataInformationText">
  {location?.subOrderId}
</div>
</div>
</div>
</div>
<div className="OrderByTransaction__orderStatusVertical">
<div className="OrderMetaHolder__base" onClick={()=>{return nav(`/productdetails/${location?.productId}`)}}>
<div className="OrderMetaHolder__productImageHolder">
<div className="ProductImage__base">
<div className="ProductImage__imageHolder">
                              <div
                                className="Image__base"
                                style={{ backgroundColor: "rgb(255, 255, 255)" }}
                              >
                                <img
                                  className="Image__actual"
                                  src={location?.productImage[0]}
                                  alt=""
                                />
                                <div
                                  className="Image__loaded Image__actual"
                                  style={{
                                    backgroundImage:
                                    `url(${location?.productImage[0]?.image})`,
                                    backgroundSize: "cover",
                                  }}
                                />
                            </div>
                            </div>
</div>
</div>
<div className="OrderMetaHolder__productDetails">
<div className="OrderMetaHolder__productName">
  {location?.productTitle}
</div>
<div className="OrderMetaHolder__priceLabel">₹{location?.finalAmount}</div>
<div className="OrderMetaHolder__priceHolder">
  <div className="OrderMetaHolder__price" />
</div>
</div>
</div>
<div className="OrderMetaHolder__deliveryMode">
<div className="OrderMetaHolder__deliveryModeTitle">
Status:{" "} 
</div>
<div className="OrderMetaHolder__deliveryModeValue">{location?.orderShipped==="Y"?"Shipped":"--"}</div>
</div>
<div className="OrderMetaHolder__deliveryMode">
<div className="OrderMetaHolder__deliveryModeTitle">
Quantity:{" "} 
</div>
<div className="OrderMetaHolder__deliveryModeValue">{location?.quantityOrdered}</div>
</div>
<div>
</div>
<div className="OrderByTransaction__cancelss">
<div className="OrderByTransaction__rightContent">

<div className="OrderByTransaction__pointsCalloutText">
  {location?.discountAmount} SpiceGold coins have been used
</div>
</div>
<label className="OrderByTransaction__tooltip">
<div className="OrderByTransaction__infoIcon" />
<input type="checkbox" />
<span>
  {" "}
  <span className="OrderByTransaction__noteBold"> Note: </span>{" "}
  SpiceGold are reversed in case of order cancellations or returns..
</span>
</label>
</div>
<div className='rowGap10'/>
{location?.digital && <div className="OrderDetailsHeader__base">
{location?.productCategory!=="c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && <div className="OrderDetailsHeader__orderPlacedHolder">
<div className="OrderDetailsHeader__labelHeader">
  Activation Code :
</div>
<div className="OrderDetailsHeader__dataInformationText">
  {location?.digital["Activation Code"]}
</div>
</div>}
<div className="OrderDetailsHeader__orderIdHolder OrderDetailsHeader__orderPlacedHolder">
<div className="OrderDetailsHeader__labelHeader">Digital Order ID :</div>
<div className="OrderDetailsHeader__dataInformationText">
{location?.digital["Digital OrderId"]}
</div>
</div>
{location?.productCategory!=="c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && <div>
<div className="OrderDetailsHeader__labelHeader">
Serial No :
</div>
<div className="OrderDetailsHeader__dataInformationText">
{location?.digital["Serial No"]}
</div>
</div>}
{location?.productCategory!=="c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && <div>
{<div className="OrderDetailsHeader__labelHeader">
Validity :
</div>}
<div className="OrderDetailsHeader__dataInformationText">
{location?.digital["Validity"]}
</div>
</div>}
</div>}
</div>


<div className="OrderByTransaction__buttonHolder" onClick={()=>{return nav('/faq')}}>
<div className="OrderByTransaction__arrowButtonHolder">
<span className="OrderByTransaction__lineArrowRight" />
<div className="OrderByTransaction__buttonHolderForUpdate">
<div className="OrderByTransaction__buttonHolderForUpdate">
  <div className="OrderByTransaction__replaceHolder">
    <div className="OrderByTransaction__review" >
      <div
        className="UnderLinedButton__base"
      >
        Help &amp; Support
        <div
          className="UnderLinedButton__underline"
          style={{ backgroundColor: "rgb(0, 0, 0)", height: 0 }}
        />
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>
</div>

<div className="OrderDetails__base">
<div className="OrderDetails__payment">
<div className="OrderViewPaymentDetails__base">
<div className="OrderViewPaymentDetails__header" style={{borderBottom: "1px solid #ececec",
paddingBottom: "10px"}}>Payment Details</div>
<div className="OrderViewPaymentDetails__subTotalsHolder">
<div className="OrderViewPaymentDetails__labelText">Item Price</div>
<div className="OrderViewPaymentDetails__infoText">₹ {location?.itemPrice}</div>
</div>
<div className="OrderViewPaymentDetails__deliverDataHolder OrderViewPaymentDetails__subTotalsHolder">
<div className="OrderViewPaymentDetails__labelText">
  Delivery &amp; Shipping Charges
</div>
<div className="OrderViewPaymentDetails__infoText">₹ {0}</div>
</div>
<div className="OrderViewPaymentDetails__discountDataHolder OrderViewPaymentDetails__subTotalsHolder">
<div className="OrderViewPaymentDetails__labelText">Discount</div>
<div className="OrderViewPaymentDetails__infoText">-₹ {location?.discountAmount}</div>
</div>
<div className="OrderViewPaymentDetails__discountDataHolder OrderViewPaymentDetails__subTotalsHolder">
<div className="OrderViewPaymentDetails__labelText">Coupon</div>
<div className="OrderViewPaymentDetails__infoText"> -₹ 0</div>
</div>
<div className="OrderViewPaymentDetails__totalHolder OrderViewPaymentDetails__subTotalsHolder">
<div className="OrderViewPaymentDetails__labelTextTotal">
  Total Price
</div>
<div className="OrderViewPaymentDetails__infoTextTotal">
  ₹ {location?.finalAmount}
</div>
</div>
<hr />

<div className="OrderViewPaymentDetails__header OrderViewPaymentDetails__displayFlex" style={{marginBottom: "5px",fontSize: "14px"}}>
Delivery Address:
<div className="OrderViewPaymentDetails__marginleft35" />
</div>
<div className="OrderViewPaymentDetails__addresstext">
<p>
  {location?.name}, {location?.address} {location?.landmark} {location?.city}
</p>
<p>{location?.state}, {location?.pinCode}</p>

</div>
<div className="rowGap10"/>

</div>
</div>
</div> */}
        </div>
      </div>
    </div>
  );
};
export default ItemDetails;
